import BasePage from './BasePage';
import { connect } from 'react-redux';
import {setModalContent} from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import Table from '../components/Table';
import $ from 'jquery';

class EditOperation extends BasePage {

    loadOnConstructor(){
		this.getOperationInterface = this.getOperationInterface.bind(this);
		this.cancelButton = this.cancelButton.bind(this);
		this.saveButton = this.saveButton.bind(this);
		this.updateOperationCallback = this.updateOperationCallback.bind(this);
		this.newOperationCallback = this.newOperationCallback.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.parseResponse = this.parseResponse.bind(this);
		this.stringBackToStringFront = this.stringBackToStringFront.bind(this);

		const {operation_id} = this.getUrlParams();
		if(operation_id !== undefined){
			this.state = {action: 'modify'};
			this.getOperationInterface(operation_id);
		}else{
			this.state = {action: 'new', isSaving: false};
			this.getOperationInterface();
		}
    }

    getOperationInterface(operationId){
		const api = this.getApi();
		api.getEditOperationInterface(operationId, this.parseResponse);
    }

    parseResponse(response){
		if(response.hasOwnProperty('auth') && response.auth === false){
			this.navigateTo('/login');
			return;
		}

		if(response.status === 'OK'){
			if(this.state.action === 'modify'){
				response.operation.creation_date = this.stringBackToStringFront(response.operation.creation_date);
				response.operation.modification_date = this.stringBackToStringFront(response.operation.modification_date);

				this.setState(prevState => {
					return {
						...prevState,
						operation: response.operation,
						taxes: response.taxes,
						i18n: response.i18n
					}
				});
			}else{
				this.setState(prevState => {
					return {
						...prevState,
						operation: response.operation,
						taxes: response.taxes,
						i18n: response.i18n
					}
				});
			}
		}else{
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		}
	}

	stringBackToStringFront(originalStr){
		const objDate = new Date(originalStr);

		return objDate.getUTCFullYear() + "-" +
			("0" + (objDate.getUTCMonth()+1)).slice(-2) + "-" +
			("0" + objDate.getUTCDate()).slice(-2) + " " +
			("0" + objDate.getUTCHours()).slice(-2) + ":" +
			("0" + objDate.getUTCMinutes()).slice(-2) + ":" +
			("0" + objDate.getUTCSeconds()).slice(-2);
	}

	cancelButton(){
		this.goBack();
    }

    saveButton(){

		let failedValidators = {};

		if($('#name').val() === ''){
			failedValidators.name = this.getTrad('fillOperationName');
		}

		if($('#default_tax').val() === '0'){
			failedValidators.default_tax = this.getTrad('selectDefaultTax');
		}

		if(this.state.operation === undefined || this.state.operation.allowed_taxes === undefined ||
			this.state.operation.allowed_taxes.length === 0){
			failedValidators.allowed_taxes = this.getTrad('selectAlmostOneAllowedTax');
		}

		if(Object.keys(failedValidators).length !== 0){
			let message = [];
			for (let m in failedValidators){
				message.push(failedValidators[m]);
			}
			this.props.setModalContent({
				title: 'Debe completar los datos obligatorios',
				body: message,
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		}

		this.setState({ isSaving: true })
		const api = this.getApi();
		if(this.state.action === 'modify'){
				api.updateOperation(this.state.operation,this.updateOperationCallback);
		}else{
				api.newOperation(this.state.operation,this.newOperationCallback);
		}
    }

    updateOperationCallback(response){
		this.setState({ isSaving: false })
	    if(response.status === 'OK'){
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: ['El impuesto ha sido modificado satisfactoriamente.'],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			    ]
		    });

		    $("#exampleModal").modal('toggle');
	    }else{
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: [this.getTrad(response.message)],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true}
			    ]
		    });

		    $("#exampleModal").modal('toggle');

	    }
    }

    newOperationCallback(response){
		this.setState({ isSaving: false })
		if(response.status !== 'OK'){

			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
				]
			});

			$("#exampleModal").modal('toggle');

		}else{
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: ['La operación ha sido creado satisfactoriamente.'],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
				]
			});

			$("#exampleModal").modal('toggle');
		}
    }

    handleChange(event) {

		let operationMod = this.state.operation?{...this.state.operation}:{};

		if(event.target.name.match(/^allowedTaxes_/)){
			const parts = event.target.name.split('_');
			operationMod.allowed_taxes = operationMod.allowed_taxes !== undefined?
				operationMod.allowed_taxes.filter((v, i, a) => a.indexOf(v) === i):[];
			if(event.target.checked){
				operationMod.allowed_taxes.push(parts[1]);
			}else{
				operationMod.allowed_taxes = operationMod.allowed_taxes.filter(tax => tax !== parts[1]);
			}
		}else{
			operationMod[event.target.name] = event.target.value;
		}

		this.setState(prevState => {
			return {
			...prevState,
			operation: operationMod
		}});
    }

    render() {
        return (
            <div className="container">
            	<Menu />
                <h3>{this.state.action === 'new'?this.getTrad('operationInsertion'):this.getTrad('operationEdition')}</h3>
                <div className="row mt-4">
			<div className="col-12">
			
			{(this.state.operation || this.state.action === 'new')?
				<form>
				  
				  <div className="form-group">
				    <label htmlFor="name">Nombre</label>
				    <input type="text" className="form-control" id="name" name="name"
				    defaultValue={this.state.operation?this.state.operation.name:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
				    <label htmlFor="default_tax">Impuesto por defecto</label>
				    <select className="form-control" id="default_tax" name="default_tax"
				    defaultValue={this.state.operation?this.state.operation.default_tax:''} onChange={this.handleChange}>
						<option value="0">{this.getTrad("selectAnOption")}</option>
						{this.state.taxes?this.state.taxes.map((tax,idx) => {
							return <option value={tax._id} key={'tax_'+idx}
								selected={this.state.operation && this.state.operation.tax === tax._id?true:undefined}>{tax.name}</option>

						}):''}
					</select>
					
				  </div>

				  <Table 
					config = {{
						items: this.state.taxes !== undefined?this.state.taxes:[],
						i18n: this.state.i18n !== undefined? this.state.i18n:[],
						checked: this.state.taxes !== undefined && this.state.operation?this.state.taxes.map(at => {
							return this.state.operation.allowed_taxes && this.state.operation.allowed_taxes.indexOf(at._id) !== -1?at._id:''
						}):[],
						disabled: [],
						mapping: [
							{original: 'name', shown: 'Tipos de impuesto', visible: true, bold: true},
							{original: '_id', shown: 'Aceptado', visible: true, display:'check', 
								prefix: 'allowedTaxes_', change_callback: this.handleChange}
						]
					}}
					 /> 

				  
				  <div className="d-flex justify-content-between align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={this.saveButton} disabled={this.state.isSaving}>{this.state.isSaving ? 'Guardando...' : 'Guardar'}</button>
					  <button type="button" className="btn btn-secondary" onClick={this.cancelButton}>Cancelar</button>
				  </div>
				</form>

			:<span>El impuesto no existe</span>}

			</div>
                </div>
			<Modal />
            </div>
        );
    }

    cursorPointer = {
	cursor: 'pointer',
	width: '100%',
	background: '#CCC',
	padding:'3px',
	fontWeight: 'bold',
	textAlign: 'center'
    }
}

const mapStateToProps = state => {
    return {
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
	    	dispatch(setModalContent(modalContent));
		}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditOperation)
